/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Reply_PlaceholderInputs */

const en_settings_tickets_reply_placeholder = /** @type {(inputs: Settings_Tickets_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a reply...`)
};

/**
* | output |
* | --- |
* | "Write a reply..." |
*
* @param {Settings_Tickets_Reply_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_reply_placeholder = /** @type {((inputs?: Settings_Tickets_Reply_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Reply_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_reply_placeholder(inputs)
});
export { settings_tickets_reply_placeholder as "settings.tickets.reply_placeholder" }